var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"4","md":"4","sm":"12"}},[_c('div',{staticClass:"textlabel",attrs:{"data-label":"Test"}},[_c('b-form-input',{attrs:{"maxlength":"15"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }